import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  DELETE_COURSE_DURATION,
  DeleteCourseDurationAction,
  GET_COURSE_DURATION,
  GET_COURSE_DURATIONS,
  GetCourseDurationAction,
  GetCourseDurationsAction,
  UPDATE_COURSE_DURATION,
  UpdateCourseDurationAction,
} from "./actionTypes";
import {
  deleteCourseDurationError,
  deleteCourseDurationSuccess,
  getCourseDurationError,
  getCourseDurationSuccess,
  getCourseDurationsError,
  getCourseDurationsSuccess,
  updateCourseDurationError,
  updateCourseDurationSuccess,
} from "./actions";
import {
  deleteCourseDuration,
  getCourseDuration,
  getCourseDurations,
  updateCourseDuration,
} from "../../helpers/backend_helper";

function* getCourseDurationsSaga({
  payload: { gradeId, courseId, request, history },
}: GetCourseDurationsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getCourseDurations,
      gradeId,
      courseId,
      request as PaginateQuery
    );
    yield put(getCourseDurationsSuccess(response.data));
  } catch (error) {
    yield put(getCourseDurationsError(error));
  }
}

function* getCourseDurationSaga({
  payload: { id, history },
}: GetCourseDurationAction) {
  try {
    const response: ResponseGenerator = yield call(getCourseDuration, id);
    yield put(getCourseDurationSuccess(response.data));
  } catch (error) {
    yield put(getCourseDurationError(error));
  }
}

function* updateCourseDurationSaga({
  payload: { request, history },
}: UpdateCourseDurationAction) {
  try {
    yield call(updateCourseDuration, request);
    yield put(updateCourseDurationSuccess());
  } catch (error) {
    yield put(updateCourseDurationError(error));
  }
}

function* deleteCourseDurationSaga({
  payload: { id, history },
}: DeleteCourseDurationAction) {
  try {
    yield call(deleteCourseDuration, id);
    yield put(deleteCourseDurationSuccess());
  } catch (error) {
    yield put(deleteCourseDurationError(error));
  }
}

function* CourseDurationSaga() {
  yield takeEvery(GET_COURSE_DURATIONS, getCourseDurationsSaga);
  yield takeEvery(GET_COURSE_DURATION, getCourseDurationSaga);
  yield takeEvery(UPDATE_COURSE_DURATION, updateCourseDurationSaga);
  yield takeEvery(DELETE_COURSE_DURATION, deleteCourseDurationSaga);
}

export default CourseDurationSaga;
